<template>
  <div class="register absolute petLogin">
		<div class="welcome">
			<div class='line1'>Hello！</div>
			<div class='line2'>欢迎来到悦宠生活！</div>
		</div>
    <div class="whiteBg" v-if="formItem === 1">
      <div class="list" :hidden="current !== 0">
        <form @submit.prevent="submit">
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-phone_"></use>
              </svg>
              <input
                type="text"
                placeholder="输入手机号码"
                v-model="account"
                required
              />
            </div>
          </div>
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <input
                type="password"
                placeholder="填写登录密码"
                v-model="password"
                required
              />
            </div>
          </div>
					<div class="item">
					  <div class="align-left">
					    <svg class="icon" aria-hidden="true">
					      <use xlink:href="#icon-code_"></use>
					    </svg>
					    <input
					      type="text"
					      placeholder="填写验证码"
					      class="codeIput"
					      v-model="codeVal"
					    />
					    <div class="code" @click="getCaptcha"><img :src="codeUrl" /></div>
					  </div>
					</div>
        </form>
      </div>
      <div class="logon" @click="submit">登录</div>
      <div class="tip"></div>
    </div>
    <div class="bottom"></div>
  </div>
</template>
<script>
import PetApi from "../../api/petAdmin";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import cookie from "@utils/store/cookie";
import { VUE_APP_API_URL } from "@utils";

const BACK_URL = "pet_login_back_url";

export default {
  name: "PetAdminLogin",
  data: function() {
    return {
      current: 0,
      account: "",
      password: "",
      captcha: "",
      formItem: 1,
      type: "login",
      logoUrl: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: true
    };
  },
  mounted: function() {
		this.getCaptcha();
  },
  methods: {
    getCaptcha() {
      this.codeUrl =
        VUE_APP_API_URL +
        "/petAdminCaptcha?" +
        "t=" + Date.parse(new Date());
    },
    async submit() {
      const { account, password, codeVal } = this;
      try {
        await this.$validator({
          account: [
            required(required.message("账号")),
          ],
          password: [
            required(required.message("密码")),
            attrs.range([6, 16], attrs.range.message("密码")),
          ],
          codeVal: [
						required(required.message("验证码")),
						attrs.length(4, attrs.length.message("验证码")),
						alpha_num(alpha_num.message("验证码"))
          ]
        }).validate({ account, password, codeVal });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      PetApi.login({ account, password, code: codeVal })
        .then(({ data }) => {
          let expires_time = data.expires_time.substring(0, 19);
          expires_time = expires_time.replace(/-/g, "/");
          expires_time = new Date(expires_time).getTime() - 28800000;
          const datas = {
            token: data.token,
            expires_time: expires_time
          };
          this.$store.commit("PETLOGIN", datas);
          const backUrl = cookie.get(BACK_URL) || "/petAdmin/index";
          cookie.remove(BACK_URL);
          this.$router.replace({ path: '/petAdmin/index' });
        })
        .catch(e => {
          this.$dialog.error(e.msg);
        });
    }
  }
};
</script>
<style scoped lang="scss">
.code img {
  width: 100%;
  height: 100%;
}
.petLogin {
	background : url("../../assets/images/loginBg.png");
	
	.whiteBg {
		width: 6.86rem;
		.logon {
			background: linear-gradient( 90deg, #FFC85F 0%, #F57300 100%);
		}
		
		.list {
			.item {
				.codeIput {margin-left: 0.7rem;}
				.code {
					background-color: #fdab46;
				}
			}
		}
	}
	
	.welcome {
		padding: 1.34rem 0.3rem 0.76rem;
		color: #fff;
		.line1 {
			font-size: 0.76rem;
		}
		.line2 {
			font-weight: 400;
			font-size: .36rem;
			color: #FFFFFF;
		}
	}
}
</style>
